import cn from 'classnames';
import { memo, useState } from 'react';

import styles from './ImgWrapper.module.scss';

const ImgWrapper = memo(({ imgUrl, imgUrlj, alt, className, imgClassName, onError }) => {
  const [errorUrl, setErrorUrl] = useState('');

  return (
    <span className={cn(styles.imgWrapper, className)}>
      <picture>
        <source srcSet={errorUrl ? errorUrl : imgUrl} type='image/webp' />
        <img
          onError={() => setErrorUrl(onError)}
          className={cn(styles.img, imgClassName)}
          src={errorUrl ? errorUrl : imgUrlj}
          alt={alt}
        />
      </picture>
    </span>
  );
});

export default ImgWrapper;
